import { createStyles, makeStyles, Theme } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      textAlign: "center",
    },
    textField: {
      marginBottom: theme.spacing(1),
    },
    loginBankIdButton: {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.light,
      "&:hover": {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
      },
      justifyContent: "center",
      marginTop: theme.spacing(3),
      width: "50%",
      [theme.breakpoints.down("xs")]: {
        width: "100%",
      },
    },
  })
);
